import { SurgicalOrdersStatus } from '../enum/surgical-orders-status'

export const isSurgicalOrderDisabled = (
  status: keyof typeof SurgicalOrdersStatus
): boolean => {
  return (
    status === SurgicalOrdersStatus.CANCELLED ||
    status === SurgicalOrdersStatus.CONCLUDED
  )
}
